import Grid from './grid.element.js';

export default Grid;

Grid.define('wje-grid', Grid);
